import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { ResponseData } from '@/utils/request';

import request from '@/utils/request';
import { freightInfoType, freightDataType } from './data'
import { getFreightInfoUrl } from './service'

export interface StateType {
    errorMsg?: string;
    getFreightInfo: freightDataType;
}

export interface ModuleType extends StoreModuleType<StateType>{
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        getListSelect: Mutation<StateType>;
    };
    actions: {
        getFreightFn: Action<StateType, StateType>;
    };
}

const initState: StateType = {
    errorMsg: undefined,
    getFreightInfo: {
        calcParam: 0,
        bubbleRatio: 0,
        calculationBubbleRatio: 0,
        checkParam: 0,
        weightPrice: 0,
        unitPrice: 0,
        priceUnit: 0,
        diversityWeightPrice: 0,
        diversityUnitPrice: 0,
        remarks: '',
        actualPrice: 0,
        volumeWeightPrice: 0,
        bubbleCalc: '',
        billingPrice: 0,
        volumeWeight: 0,
        weight: 0,
        bulkWeightPrice: 0,
        bulkUnitPrice: 0,
        bulkDiversityWeightPrice:0,
        bulkDiversityUnitPrice: 0,
        bulkFlag: false
    }
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'freightcalculation',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        getListSelect(state, payload){
            state.getFreightInfo = payload
        },
    },
    actions: {
        async getFreightFn({commit}, params:freightInfoType){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getFreightInfoUrl(params)
                const { body } = req
                const data = body || []
                commit('getListSelect', data)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
    }
}

export default StoreModel